__turbopack_context__.v({
  "content": "HeroSection-module__7jDW-q__content",
  "description": "HeroSection-module__7jDW-q__description",
  "hero-container": "HeroSection-module__7jDW-q__hero-container",
  "lottie-container": "HeroSection-module__7jDW-q__lottie-container",
  "root": "HeroSection-module__7jDW-q__root",
  "video-container": "HeroSection-module__7jDW-q__video-container",
});
